<script lang="ts">
  let { title = "", value = "", trend = "", trendUp = true, subtitle = "" } = $props();
</script>

<div class="rounded-xl border border-base-200 bg-base-100 p-6 shadow-sm flex flex-col justify-between hover:border-base-300 transition-colors">
  <div class="flex flex-row items-center justify-between pb-2">
    <h3 class="tracking-tight text-sm font-medium text-base-content/80">{title}</h3>
  </div>
  <div>
    <div class="text-3xl font-bold tracking-tight">{value}</div>
    {#if trend || subtitle}
      <p class="text-xs text-base-content/70 mt-1 flex items-center">
        {#if trend}
          <span class="font-medium mr-1 {trendUp ? 'text-success' : 'text-error'}">{trend}</span>
        {/if}
        {subtitle}
      </p>
    {/if}
  </div>
</div>
